import { apiRequest } from "./apiClient";

/* =========================
   SEND OTP
========================= */

export const sendParentOtp = async ({ mobileNo, applicationId }) => {
  return apiRequest("sendParentOtp", "POST", {
    mobileNo,
    applicationId,
  });
};

/* =========================
   VERIFY OTP
========================= */

export const verifyParentOtp = async ({
  mobileNo,
  applicationId,
  password,
  deviceToken,
}) => {
  return apiRequest("verifyParentOtp", "POST", {
    mobileNo,
    applicationId,
    password,
    deviceToken,
  });
};

/* =========================
   VERIFY TOKEN
========================= */

export const verifyTokenApi = async (token) => {
  // Replace "verifyToken" with your actual backend endpoint to verify token / get profile
  return apiRequest("verifyToken", "GET", null, token);
};


/* =========================
   CREATE ORDER
========================= */

export const createOrder = async (amount, token) => {
  return apiRequest("createOrder", "POST", amount, token);
};


/* =========================
   VERIFY PAYMENT
========================= */

export const verifyPayment = async (data, token) => {
  return apiRequest("verifyPayment", "POST", data, token);
};

/* =========================
   SCHEDULE DOWNGRADE PLAN
========================= */

export const scheduleDowngradePlan = async (data, token) => {
  return apiRequest("scheduleDowngradePlan", "POST", data, token);
};